import { createAsyncThunk } from "@reduxjs/toolkit";
import * as vendingService from "data/server_apis/vendingServices";

export const machinePhotosState = {
  createMachinePhotosLoading: {},
  createMachinePhotosError: {},
  createMachinePhotosErrorMessage: {},
  createMachinePhotosSuccess: {},

  deleteMachinePhotosLoading: {},
  deleteMachinePhotosError: {},
  deleteMachinePhotosErrorMessage: {},
  deleteMachinePhotosSuccess: {},
};

export const createMachinePhotosThunk = createAsyncThunk(
  "vending/createMachinePhotos",
  async (data, { rejectWithValue }) => {
    try {
      return (await vendingService.createMachinePhotos(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deleteMachinePhotoThunk = createAsyncThunk(
  "vending/deleteMachinePhotos",
  async (data, { rejectWithValue }) => {
    try {
      return (await vendingService.deleteMachinePhotos(data.id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const machinePhotoBuilder = (builder) => {
  builder
    .addCase(createMachinePhotosThunk.pending, (state, action) => {
      state.createMachinePhotosLoading[action.meta.arg.machine] = true;
      state.createMachinePhotosError[action.meta.arg.machine] = false;
      state.createMachinePhotosErrorMessage[action.meta.arg.machine] = null;
      state.createMachinePhotosSuccess[action.meta.arg.machine] = false;
    })
    .addCase(createMachinePhotosThunk.rejected, (state, action) => {
      state.createMachinePhotosLoading[action.meta.arg.machine] = false;
      state.createMachinePhotosError[action.meta.arg.machine] = true;
      state.createMachinePhotosErrorMessage[action.meta.arg.machine] =
        action.payload?.message;
      state.createMachinePhotosSuccess[action.meta.arg.machine] = false;
    })
    .addCase(createMachinePhotosThunk.fulfilled, (state, action) => {
      state.createMachinePhotosLoading[action.meta.arg.machine] = false;
      state.createMachinePhotosError[action.meta.arg.machine] = false;
      state.createMachinePhotosErrorMessage[action.meta.arg.machine] = null;
      state.createMachinePhotosSuccess[action.meta.arg.machine] = true;

      const machine = state.machines.find(
        (machine) => machine.id === action.payload.machine
      );
      if (machine) {
        machine.photos.push(action.payload);
      }
    });

  builder
    .addCase(deleteMachinePhotoThunk.pending, (state, action) => {
      state.deleteMachinePhotosLoading[action.meta.arg.id] = true;
      state.deleteMachinePhotosError[action.meta.arg.id] = false;
      state.deleteMachinePhotosErrorMessage[action.meta.arg.id] = null;
      state.deleteMachinePhotosSuccess[action.meta.arg.id] = false;
    })
    .addCase(deleteMachinePhotoThunk.rejected, (state, action) => {
      state.deleteMachinePhotosLoading[action.meta.arg.id] = false;
      state.deleteMachinePhotosError[action.meta.arg.id] = true;
      state.deleteMachinePhotosErrorMessage[action.meta.arg.id] =
        action.payload?.message;
      state.deleteMachinePhotosSuccess[action.meta.arg.id] = false;
    })
    .addCase(deleteMachinePhotoThunk.fulfilled, (state, action) => {
      state.deleteMachinePhotosLoading[action.meta.arg.id] = false;
      state.deleteMachinePhotosError[action.meta.arg.id] = false;
      state.deleteMachinePhotosErrorMessage[action.meta.arg.id] = null;
      state.deleteMachinePhotosSuccess[action.meta.arg.id] = true;

      const machine = state.machines.find(
        (machine) => machine.id === action.meta.arg.machine
      );
      console.log("mc", machine);
      if (machine) {
        // const photoIndex = machine.photos.findIndex(
        //   (photo) => photo.id === action.meta.arg.id
        // );
        console.log("Arg", action.meta.arg);
        machine.photos = machine.photos.filter(
          (photo) => photo.id !== action.meta.arg.id
        );
        console.log("photos", machine.photos);
      }
    });
};
